module.exports = "/assets/data/8972f968be3db1e4354ae0cd273e6e9b-NR32.data.json";